import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LotPhotoPage } from './lot-photo.page';

const routes: Routes = [
  { path: '', component: LotPhotoPage },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LotPhotoRoutingModule { }
